export default __webpack_public_path__ + "static/media/trezor-logo.4e0a62c2.svg";